
// ⚡ Validate environment variables FIRST — before any React renders
import '@/lib/env';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import GlobalErrorBoundary from '@/components/global/GlobalErrorBoundary';
import SubdomainRouter from './SubdomainRouter';
import { initObservability } from '@/lib/observability';

// 🔍 Initialize telemetry, error tracking, and usage analytics pipelines
initObservability();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  // <React.StrictMode>
    <GlobalErrorBoundary surface="Application">
      <HelmetProvider>
        <SubdomainRouter />
      </HelmetProvider>
    </GlobalErrorBoundary>
  // </React.StrictMode>
);
